var PostMessages = function () {

    var intervalId,
    lastHash,
    attachedCallback,
    window = this;

    return {
        receiveMessage: function (callback, sourceOrigin) {

            if (window['postMessage']) {
                if (callback) {
                    attachedCallback = function (e) {
                        if ((typeof sourceOrigin === 'string' && e.origin !== sourceOrigin)
                        || (Object.prototype.toString.call(sourceOrigin) === "[object Function]" && sourceOrigin(e.origin) === !1)) {
                            return !1;
                        }
                        callback(e);
                    };
                }
                if (window['addEventListener']) {
                    window[callback ? 'addEventListener' : 'removeEventListener']('message', attachedCallback, !1);
                } else {
                    window[callback ? 'attachEvent' : 'detachEvent']('onmessage', attachedCallback);
                }
            } else {
                intervalId && clearInterval(intervalId);
                intervalId = null;

                if (callback) {
                    intervalId = setInterval(function () {
                        var hash = document.location.hash,
                        re = /^#?\d+&/;
                        if (hash !== lastHash && re.test(hash)) {
                            lastHash = hash;
                            callback({ data: hash.replace(re, '') });
                        }
                    }, 100);
                }
            }
        }
    };
}();

PostMessages.receiveMessage(function (message) {

    if (message.data.Action === 'SetUser') {
        Vendd.MessageBus.publishAsync(Vendd.UserSelect, new Vendd.UserSelect.Messages.SubmitSetInterfaceUserInlineAdmin({ 'LoginName': message.data.UserEmail.trim(), 'RedirectToAccount': message.data.RedirectToAccount }));
    }

    if (message.data.Action === 'SetOrder') {
        Vendd.MessageBus.publishAsync(Vendd.UserSelect, new Vendd.UserSelect.Messages.SubmitSetInterfaceUserInlineAdmin({ 'LoginName': message.data.UserEmail.trim(), 'RedirectToAccount': message.data.RedirectToAccount, 'OrderId': message.data.OrderId }));
    }

}, LhApp.Context.InLineAdminEndpoint);

